import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function DetailUser({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const employee = useSelector((state) => state.employee);

  useEffect(() => {
    dispatch(actions.employeeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (employee.isLoading || employee.rows) {
    return <Loading />;
  }
  if (!employee.isLoading && employee.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div className=" flex justify-center px-10 ">
          <Card className=" p-14 justify-center  shadow-md">
            <div className="text-2xl   text-center font-serif pb-8">
              ข้อมูลผู้ใช้
            </div>
            <div className="grid grid-flow-row-dense grid-cols-3 ">
              <div className="col-span-1">
                <div className="w-full ">
                  {employee?.image ? (
                    <img
                      src={employee?.image?.url}
                      className="w-48 rounded-lg border -translate-y-2"
                    />
                  ) : (
                    <div className="w-full  shadow-2xl">
                      <img
                        src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        className="w-48 rounded-lg border"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-span-2">
                <div className="flex  pt-4 ">
                  <div className="w-1/2  pl-24  text-md font-bold">
                    ชื่อผู้ใช้
                  </div>{' '}
                  <div className="w-1/2 ">
                    {employee?.firstname || ''} {employee?.lastname || ''}
                  </div>
                </div>
                <div className="flex  pt-4 ">
                  <div className="w-1/2  pl-24  text-md font-bold">
                    ชื่อเล่น
                  </div>{' '}
                  <div className="w-1/2 ">{employee?.nickname || ''}</div>
                </div>
                <div className="flex  pt-10">
                  <div className="w-1/2 pl-24 text-md font-bold">แผนก</div>
                  <div className="w-1/2">
                    {employee?.department?.name || ''}{' '}
                  </div>
                </div>

                <div className="flex  pt-10">
                  <div className="w-1/2 pl-24 text-md font-bold">บทบาท</div>
                  <div className="w-1/2">{employee?.role?.name || ''} </div>
                </div>
              </div>
            </div>
            {/* <div className="flex  pt-10">
              <div className="w-2/4 ">
                {employee?.image ? (
                  <img
                    src={employee?.image?.url}
                    className="w-56 rounded-lg border"
                  />
                ) : (
                  <div className="w-16">
                    <img
                      src={employee?.image?.url}
                      className="w-56 rounded-lg border"
                    />
                  </div>
                )}
              </div>
              <div className="w-1/2  pl-4">ชื่อผู้ใช้</div>{' '}
              <div className="w-1/2 ">
                {employee?.firstname} {employee?.lastname}
              </div>
              <br />
              <div className="w-1/2">แผนก</div>
              <div className="w-1/2">{employee?.department?.name} </div>
              <div className="flex  pt-10">
                <div className="w-1/2">บทบาท</div>
                <div className="w-1/2">{employee?.role?.name} </div>
              </div>
            </div> */}
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
DetailUser.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DetailUser.defaultProps = {
  title: '',
  subtitle: '',
};
